$(document).ready(function(){
    $('.masthead-slider').slick({
        rows: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        arrows: false,
        autoplaySpeed: 6000,
        fade: true,
        speed: 2500,
    });

    $('.projects-slider').slick({
        centerMode: true,
        infinite: true,
        variableWidth: false,
        nextArrow: '.next-slide',
        prevArrow: '.prev-slide',
        waitForAnimate: false,
        draggable: true,
        swipeToSlide: true,
        mobileFirst: true,
        responsive : [
            {
                breakpoint: 768,
                settings: {
                    centerMode: true,
                    slidesToShow: 3,
                    variableWidth: true
                }
            }
        ]
    });

    /* Metrics functionality */
    function displayMetrics(){
        $('.metric-item').each(function () {
            let $this = $(this);
            if(!$this.hasClass('active') && isScrolledIntoView($this) === true){

                $this.addClass('active');

                $this.children('.metric').children('.quantity').each(function () {
                    $(this).prop('value',0).animate({
                        Counter: $(this).text()
                    }, {
                        duration: 1000,
                        easing: 'swing',
                        step: function (now) {
                            $(this).text(Math.ceil(now));
                        }
                    });
                });

            }
        });
    }

    displayMetrics();

    $(window).scroll(function () {
        displayMetrics();
    });

    function isScrolledIntoView(elem) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();

        var elemTop = $(elem).offset().top;
        var elemBottom = elemTop + $(elem).height();

        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }
    /* Ends metrics functionality */

});